import './index.scss';
import React from 'react';
import emptyImgMap from './imageMap';
import '../../styles/listBlankV1.scss';
import { getCurrentSystem } from '@umu/ukit-lang';

import { components } from 'common';
import { IProps } from './interface';

const { If } = components;
const { PreImg } = components;

export default function (props: IProps) {
	const { type, blankImg = '', className = '', title = '', desc = '', button, children, buttonEvent, buttonText } = props;

	const renderV1 = ()=>{
		return (
            <div className={`list-blank-v1-pc ${className}`}>
                <If condition={!!blankImg}>
                    <PreImg>
                        <img className="list-blank-img" src={blankImg} />
                    </PreImg>
                </If>
                <div className="list-blank-text">
                    <If condition={!!title}>
                        <p className="list-blank-title">{title}</p>
                    </If>
                    <If condition={!!desc}>
                        <p className="list-blank-desc">{desc}</p>
                    </If>
                    {children ? children : null}
                </div>
            </div>
        );
	}
	const renderV2 = ()=>{
		if(!type){
			return renderV1();
		}
		const isOrientalArea = ['cn', 'tw', 'co'].includes(getCurrentSystem().toLocaleLowerCase());
        const url = isOrientalArea ? emptyImgMap[type].cn : emptyImgMap[type].com;

        return (
            <div className={`list-blank-pc ${className}`}>
                <img className="list-blank-img" src={url} />
                <div className="list-blank-text">
                    {title ? <p className="list-blank-title">{title}</p> : null}
                    {desc ? <p className="list-blank-desc"> {desc}</p> : null}
                </div>
                {buttonEvent ? (
                    <div className="list-blank-operation">
                        <div className="operation-button" onClick={buttonEvent}>
                            {buttonText}
                        </div>
                    </div>
                ) : null}
                {
                    button ? <div className="list-blank-operation">
                    {button}
                </div> : null
                }
            </div>
        );
	}

    return renderV2();
};
